export default __webpack_public_path__ + "static/media/section-icon-1.b1412bf6.svg";